import Box from "@mui/material/Box";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import React from "react";

const locations = [
    { name: 'Cornerstone', location: 'Cornerstone Christian Academy', address: '4745 Redman Rd, Brockport, NY 14420', map: 'https://goo.gl/maps/2Pj7Ji2YNWXMaG139' },
    { name: 'Swift', location: 'Basil Marella Park', address: '975 English Rd, Rochester, NY 14626', map: 'https://goo.gl/maps/Dc7jDGwxNE5oZuFT8' },
    { name: 'Intensity', location: 'Henry Minier Field', address: '2911 State Route 352, Big Flats, NY, 14814', map: 'https://goo.gl/maps/XyeWWo9Y1QDCbzws9' },
    { name: 'Lima Christian', location: 'Lima Christian School', address: '1574 Rochester St, Lima, NY 14485', map: 'https://goo.gl/maps/qJFDGrSCDk8b2GJE6' },
    { name: 'Grasshoppers', location: 'Rockburger Field', address: '3511 Ray Hill Rd Andover NY 14806', map: 'https://maps.app.goo.gl/CtGkMdZSiwcqGdXeA' },
    { name: 'RSD', location: 'Rochester School For the Deaf', address: '1545 St Paul St, Rochester, NY 14621', map: 'https://goo.gl/maps/HsKkWQbSVYJ3yacr6' },
    { name: 'Rapids', location: 'Grace and Truth Sports Park', address: '373 N Greece Rd, Hilton, NY 14468', map: 'https://goo.gl/maps/wBKKsQidPYqsQYN79' },
    { name: 'Scarlet Knights', location: 'Bullis Park', address: '1777 Canandaigua Rd, Macedon, NY 14502', map: 'https://goo.gl/maps/VUH1SqonHFfcwD969' },
    { name: 'Union Springs', location: 'Union Springs Academy', address: '40 Spring Street Rd, Union Springs, NY 13160', map: 'https://goo.gl/maps/GePL5FHipkHiraax5' },
    { name: 'SC United', location: 'Elks Lodge', address: '6791 North Canal Road, Lockport, NY 14094', map: 'https://maps.app.goo.gl/71xZt1AzxczXNHns5' }

];

export default function Locations()  {

    return (
            <Box sx={{paddingTop: '20px'}}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Team</TableCell>
                                <TableCell>Location</TableCell>
                                <TableCell>Address</TableCell>
                                <TableCell>Map</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {locations.map((location) => (
                                <TableRow
                                    key={location.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">
                                        {location.name}
                                    </TableCell>
                                    <TableCell>{location.location}</TableCell>
                                    <TableCell>{location.address}</TableCell>
                                    <TableCell><a href={location.map} style={{color: 'white'}}>Map</a></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
    )
}
